/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import config from '../config';
import {Events} from '@exc/shared';
import {messenger} from '../Messenger';
import {Nps, NpsApiProperties} from '@adobe/exc-app/nps';

const nps = {
  triggerNps: (): void => {
    messenger.send(Events.TRIGGER_NPS);
  }
} as Nps;

Object.defineProperty(nps as NpsApiProperties, 'config', {
  get: () => {
    return config.get('nps');
  },
  set: value => {
    config.set({['nps']: value});
  }
});
export default nps;
